import { DisplaySwitch } from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import TotalSupplyGraph from './TotalSupplyGraph';
import CollateralAtRiskGraph from './CollateralAtRiskGraph';

export default function CollateralAssetsTabs({
  marketAddress
}: {
  marketAddress: string;
}) {
  const [activeDisplayOption, setActiveDisplayOption] =
    useState('total_supply');

  const displayOptions = useMemo(
    () => [
      { key: 'total_supply', value: 'Collateral Supply' },
      { key: 'at_risk', value: 'At Risk' }
    ],
    []
  );

  return (
    <>
      <DisplaySwitch
        data={displayOptions}
        activeOption={activeDisplayOption}
        onChange={setActiveDisplayOption}
      />
      {activeDisplayOption === 'total_supply' ? (
        <TotalSupplyGraph marketAddress={marketAddress} />
      ) : (
        <CollateralAtRiskGraph marketAddress={marketAddress} />
      )}
    </>
  );
}
